<template>
  <div class="purchase container" v-infinite-scroll="getPurchase" infinite-scroll-disabled="busy" infinite-scroll-distance="150" infinite-scroll-root>
    <v-card v-if="!orders.length" class="py-14 text-center">
      {{ isEmpty ? '沒有購買記錄' : 'Loading...' }}
    </v-card>
    <v-card class="pa-4 my-8 order" v-for="order in orders">
      <div class="text-right font-weight-regular">
        <span 
          v-if="checkIsShip(order) || !order.cart_orders[0].orders[0].product || ['video', 'story', 'photo'].includes(order.cart_orders[0].orders[0].product.product_type)" 
          class="green--text"
        >
          已出貨
        </span>
        <span v-else class="red--text">未出貨</span>
      </div>
      <div class="seller" v-for="cart in order.cart_orders" :key="cart.id">
        <a class="d-flex align-center" v-if="cart.seller" @click="$router.push(`/seller/${cart.seller.id}`)">
          <v-avatar size="25" class="mr-1">
            <v-img :src="$HOST_URL + cart.seller.usericon"/>
          </v-avatar>
          {{ cart.seller.nickname }}
        </a>
        <v-divider class="my-2"></v-divider>
        <template v-for="cart_order in cart.orders">
          <div class="py-2" :key="cart_order.id">
            <div 
              class="d-flex pointer"
              @click="cart_order.product ? (['story', 'photo'].includes(cart_order.product.product_type) ? $root.$emit('story', cart.seller, cart_order.product, cart_order.product.product_type) : $router.push(`/product/${cart_order.product.id}`)) : ''">
              <v-img 
                aspect-ratio="1" 
                max-width="60" 
                width="60" 
                :src="cart_order.product ? $func.productImagePreview(cart_order.product) : '/img/product_not_found.png'">
              </v-img>
              <div class="product-title flex-grow-1">
                <div :class="{'red--text': !cart_order.product}">{{ cart_order.product ? cart_order.product.title : '已刪除的商品' }}</div>
                <div class="d-flex align-center justify-end">
                  <div class="peach"></div>
                  {{ cart_order.product ? cart_order.product.price : cart_order.record_price }}
                </div>
              </div>
            </div>
          </div>
          <v-divider></v-divider>
        </template>
      </div>
      <div class="information">
        <div class="order-detail">
          <div v-if="order.order_number">
            <div>訂單編號:</div>
            <div>{{ order.order_number }}</div>
          </div>
          <div>
            <div>建立時間:</div>
            <div>{{ order.checkout_time }}</div>
          </div>
          <div v-if="order.name">
            <div>收件人:</div>
            <div>{{ order.name }}</div>
          </div>
          <div v-if="order.tel">
            <div>電話:</div>
            <div>{{ order.tel }}</div>
          </div>
          <div v-if="order.notify_email">
            <div>Email:</div>
            <div>{{ order.notify_email }}</div>
          </div>
          <div v-if="order.shop_name">
            <div>分店:</div>
            <div>{{ order.shop_name }}</div>
          </div>
          <div v-if="order.shop_address">
            <div>地址:</div>
            <div>{{ order.shop_address }}</div>
          </div>
        </div>
        <div class="amount pa-2">
          <div>
            <span>商品桃子</span>
            <span class="d-flex align-center">
              {{ calcTotalPrice(order) }}
            </span>
          </div>
          <div>
            <span>總運費</span>
            <span class="d-flex align-center">
              {{ calcShippingFee(order) }}
            </span>
          </div>
          <div class="total">
            <span>總桃子</span>
            <span class="d-flex align-center">
              <div class="peach"></div>
              {{ calcTotalPrice(order) + calcShippingFee(order) }}
            </span>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import CustomizeHeader from '@/components/CustomizeHeader'
export default {
  components: { CustomizeHeader },
  data() {
    return {
      busy: false,
      page: 1,
      orders: [],
      isEmpty: false
    }
  },
  methods: {
    getPurchase() {
      this.busy = true
      this.axios.get(`/member/purchase?page=${this.page}&size=1`).then(response => {
        this.orders = this.orders.concat(response.data.data.map(order => {
          order.cart_orders = order.cart_orders.length ? order.cart_orders : [{seller: order.orders[0].seller, orders: order.orders}]
          return order
        }))
        if(this.orders.length == 0) {
          this.isEmpty = true
        }
        if(this.page != response.data.last_page) {
          this.page += 1
          this.busy = false
        }
      })
    },
    calcTotalPrice(order) {
      return order.cart_orders.reduce((prev, cart) => {
        return prev + cart.orders.reduce((prev, cart_order) => {
          return prev + (cart_order.product ? cart_order.product.price : cart_order.record_price)
        }, 0)
      }, 0)
    },
    calcShippingFee(order) {
      return order.cart_orders.filter(cart => cart.fee).reduce((prev, cart) => {
        return prev + cart.fee
      }, 0)
    },
    checkIsShip(order) {
      return order.cart_orders.every(cart => {
        return cart.orders.every(cart_order => {
          return cart_order.ship
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1000px;
}
.purchase {
  min-height: 100%;
  .order {
    .seller {
      padding: 16px;
      @include mobile {
        padding: 16px 0;
      }
      a {
        color: unset !important;
      }
      .product-title {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: 14px;
        padding: 0 12px;
      }
      .product-price {
        float: right;
      }
    }
    .information {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      @include mobile {
        display: block;
      }
    }
    .amount {
      margin-left: auto;
    }
    .order-detail {
      color: grey;
      padding: 8px;
      font-size: 14px;
      max-width: 500px;
      @include tablet {
        max-width: 350px;
        font-size: 13px;
      }
      @include mobile {
        max-width: 100%;
      }
      & > div {
        display: flex;
        div:first-child {
          min-width: 80px;
        }
      }
    }
  }
}
</style>